export default __webpack_public_path__ + "assets/fonts/Nunito-Bold-7d077113.woff2";